import { Card, CardHeader, Divider } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Visitor } from '../../api/types/visits';
import { VisitorTable } from '../organisms/visitor-table';

interface Props {
  visitors: Visitor[];
  actionsSlot: (visitor: Visitor) => ReactNode;
}

export const VisitContactInfo = ({ visitors, actionsSlot }: Props) => {
  const { t } = useTranslation(['visit']);

  return (
    <Card variant="outlined">
      <CardHeader title={t('visit:information.cardTitle')} />
      <Divider />
      <VisitorTable actionsSlot={actionsSlot} visitors={visitors} />
    </Card>
  );
};
